/**
 *所有API接口url
 */
let urls = {}

/**
 * 用户信息部分
 * @name urls.user
 */

urls.user = {
  // 登录
  login: '/api/login',
  // 获取用户登录信息
  loginStatus: '/api/user/getCurUserInfo',
  // 退出登录
  logout: '/api/user/logout',
  find: '/api/user/find',
  get: '/api/user/get',
  create: '/api/user/create',
  update: '/api/user/update',
  delete: '/api/user/delete',
  activate: '/api/user/activate',
  changePassword: '/api/user/changePassword',
  resetPassword: '/api/user/resetPassword',
}
urls.common = {
  getQiniuUptoken: '/api/qiniu/uptoken'
}
urls.category = {
  find: '/api/category/find',
  create: '/api/category/create',
  update: '/api/category/update',
  delete: '/api/category/delete',
}

urls.brand = {
  find: '/api/brand/find',
  create: '/api/brand/create',
  update: '/api/brand/update',
  delete: '/api/brand/delete',
}
urls.department = {
  find: '/api/department/find',
  get: '/api/department/get',
  create: '/api/department/create',
  update: '/api/department/update',
  delete: '/api/department/delete',
}
/**
 * 角色部分
 * @name urls.role
 */

urls.role = {
  find: '/api/role/find',
  get: '/api/role/get',
  create: '/api/role/create',
  update: '/api/role/update',
  delete: '/api/role/delete',
  getPermission: '/api/role/getPermission',
}

urls.customer = {
  find: '/api/customer/find',
  get: '/api/customer/get',
  create: '/api/customer/create',
  update: '/api/customer/update',
  delete: '/api/customer/delete',
}

urls.product = {
  find: '/api/product/find',
  findByCategroy: '/api/product/findByCategory',
  get: '/api/product/get',
  create: '/api/product/create',
  update: '/api/product/update',
  delete: '/api/product/delete',
  copyFromSample: '/api/product/copyFromSample',
  findAttribute: '/api/product/findAttribute',
  createAttribute: '/api/product/createAttribute',
  updateAttribute: '/api/product/updateAttribute',
  deleteAttribute: '/api/product/deleteAttribute',
  findMedia: '/api/product/findMedia',
  createMedia: '/api/product/createMedia',
  deleteMedia: '/api/product/deleteMedia',
  attachCategory: '/api/product/attachCategory',
  detachCategory: '/api/product/detachCategory',
}
urls.sku = {
  find: '/api/sku/find',
  create: '/api/sku/create',
  update: '/api/sku/update',
  delete: '/api/sku/delete',
  findAttribute: '/api/sku/findAttribute',
  createAttribute: '/api/sku/createAttribute',
  updateAttribute: '/api/sku/updateAttribute',
  deleteAttribute: '/api/sku/deleteAttribute',
}
urls.marketing = {
  findClientHomeFeatured: '/api/marketing/findClientHomeFeatured',
  createClientHomeFeatured: '/api/marketing/createClientHomeFeatured',
  updateClientHomeFeatured: '/api/marketing/updateClientHomeFeatured',
  deleteClientHomeFeatured: '/api/marketing/deleteClientHomeFeatured',
}
urls.order = {
  find: '/api/order/find',
  get: '/api/order/get',
  create: '/api/order/create',
  update: '/api/order/update',
  delete: '/api/order/delete',
  cancel: '/api/order/cancel',
  createReport: '/api/order/createReport',
}
urls.redenvelope = {
  find: '/api/redenvelope/find',
  get: '/api/redenvelope/get',
  create: '/api/redenvelope/create',
  update: '/api/redenvelope/update',
  delete: '/api/redenvelope/delete',
  findOpen: '/api/redenvelope/findOpen',
  exportOpen: '/api/redenvelope/exportOpen',
  findQRCode: '/api/redenvelope/findQRCode',
  createQRCode: '/api/redenvelope/createQRCode',
  deleteQRCode: '/api/redenvelope/deleteQRCode',
  downloadQRCode: '/api/redenvelope/downloadQRCode',
  findCategory: '/api/redenvelope/findCategory',
  createCategory: '/api/redenvelope/createCategory',
  updateCategory: '/api/redenvelope/updateCategory',
  deleteCategory: '/api/redenvelope/deleteCategory',
  activate: '/api/redenvelope/activate',
  clearFailed: '/api/redenvelope/clearFailed'
}
urls.lottery = {
  find: '/api/lottery/find',
  get: '/api/lottery/get',
  create: '/api/lottery/create',
  update: '/api/lottery/update',
  delete: '/api/lottery/delete',
  findDraw: '/api/lottery/findDraw',
  exportDraw: '/api/lottery/exportDraw',
  findQRCode: '/api/lottery/findQRCode',
  createQRCode: '/api/lottery/createQRCode',
  deleteQRCode: '/api/lottery/deleteQRCode',
  downloadQRCode: '/api/lottery/downloadQRCode',
  findPrize: '/api/lottery/findPrize',
  createPrize: '/api/lottery/createPrize',
  updatePrize: '/api/lottery/updatePrize',
  deletePrize: '/api/lottery/deletePrize',
  activePrize: '/api/lottery/activePrize',
  findPrizeXref: '/api/lottery/findPrizeXref',
  createPrizeXref: '/api/lottery/createPrizeXref',
  updatePrizeXref: '/api/lottery/updatePrizeXref',
  deletePrizeXref: '/api/lottery/deletePrizeXref',
}

urls.shop = {
  find: '/api/shop/find',
  get: '/api/shop/get',
  create: '/api/shop/create',
  update: '/api/shop/update',
  delete: '/api/shop/delete',
  findArea: '/api/shop/findArea',
  findRegion: '/api/shop/findRegion',
}
urls.vote = {
  find: '/api/vote/find',
  get: '/api/vote/get',
  create: '/api/vote/create',
  update: '/api/vote/update',
  delete: '/api/vote/delete',
  findBanner: '/api/vote/findBanner',
  createBanner: '/api/vote/createBanner',
  updateBanner: '/api/vote/updateBanner',
  deleteBanner: '/api/vote/deleteBanner',
  findPrize: '/api/vote/findPrizeAll',
  createPrize: '/api/vote/createPrize',
  updatePrize: '/api/vote/updatePrize',
  deletePrize: '/api/vote/deletePrize',
  findPrizeXref: '/api/vote/findPrize',
  createPrizeXref: '/api/vote/createPrizeXref',
  updatePrizeXref: '/api/vote/updatePrizeXref',
  deletePrizeXref: '/api/vote/deletePrizeXref',
  findPresentAll: '/api/vote/findPresentAll',
  createPresent: '/api/vote/createPresent',
  updatePresent: '/api/vote/updatePresent',
  deletePresent: '/api/vote/deletePresent',
  findPresentXref: '/api/vote/findPresentXref',
  createPresentXref: '/api/vote/createPresentXref',
  updatePresentXref: '/api/vote/updatePresentXref',
  deletePresentXref: '/api/vote/deletePresentXref',
  findPresentOrder: '/api/vote/findPresentOrder',
  deletePresentOrder: '/api/vote/deletePresentOrder',
  findResult: '/api/vote/findResult',
  deleteResult: '/api/vote/deleteResult',
  findPlayerAll: '/api/vote/findPlayerAll',
  deletePlayer: '/api/vote/deletePlayer',
  downloadQRCode: '/api/vote/downloadQRCode',
}

export default urls



// WEBPACK FOOTER //
// ./src/config/urls.js